
  import { defineComponent } from 'vue';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import keyCountryIndicatorApi from '../api/keyCountryIndicator';
  import KeyCountryIndicatorForm from '../components/key-country-indicator/KeyCountryIndicatorForm.vue';
  import { TKeyCountryIndicator, TKeyCountryIndicatorSave } from '../types/keyCountryIndicator';

  const PERMISSIONS = {
    update: Constants.Permissions.KeyCountryIndicatorUpdate,
  };

  export default defineComponent({
    name: 'KeyCountryIndicatorEdit',
    components: {
      PageTitle,
      KeyCountryIndicatorForm,
    },
    mixins: [security],
    data(): { isLoading: boolean; item: TKeyCountryIndicator | null } {
      return {
        isLoading: false,
        item: null,
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.update).then((isAllowed: boolean) => {
        if (!isAllowed) return;

        this.findItem();
      });
    },
    methods: {
      async save({ item, onSuccess, onError }: TKeyCountryIndicatorSave) {
        try {
          this.isLoading = true;
          await keyCountryIndicatorApi.edit(this.getItemId, item);
          onSuccess();
        } catch {
          onError();
        } finally {
          this.isLoading = false;
        }
      },
      async findItem() {
        try {
          this.isLoading = true;
          const response = await keyCountryIndicatorApi.find(this.getItemId);
          this.item = response.data;
        } catch {
          this.item = null;
        } finally {
          this.isLoading = false;
        }
      },
    },
    computed: {
      getItemId() {
        return Number(this.$route.params.id);
      },
    },
  });
